var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.328 9.82013L8.328 11.8297H4.5V23.8872H20.5V11.8297H16.672L14.672 9.82013H10.328ZM9.5 7.81055H15.5L17.5 9.82013H21.5C21.7652 9.82013 22.0196 9.92599 22.2071 10.1144C22.3946 10.3029 22.5 10.5584 22.5 10.8249V24.892C22.5 25.1585 22.3946 25.4141 22.2071 25.6025C22.0196 25.7909 21.7652 25.8968 21.5 25.8968H3.5C3.23478 25.8968 2.98043 25.7909 2.79289 25.6025C2.60536 25.4141 2.5 25.1585 2.5 24.892V10.8249C2.5 10.5584 2.60536 10.3029 2.79289 10.1144C2.98043 9.92599 3.23478 9.82013 3.5 9.82013H7.5L9.5 7.81055ZM12.5 22.8824C11.0413 22.8824 9.64236 22.3002 8.61091 21.2638C7.57946 20.2274 7 18.8217 7 17.3561C7 15.8904 7.57946 14.4847 8.61091 13.4483C9.64236 12.412 11.0413 11.8297 12.5 11.8297C13.9587 11.8297 15.3576 12.412 16.3891 13.4483C17.4205 14.4847 18 15.8904 18 17.3561C18 18.8217 17.4205 20.2274 16.3891 21.2638C15.3576 22.3002 13.9587 22.8824 12.5 22.8824ZM12.5 20.8728C13.4283 20.8728 14.3185 20.5023 14.9749 19.8428C15.6313 19.1833 16 18.2888 16 17.3561C16 16.4234 15.6313 15.5289 14.9749 14.8693C14.3185 14.2098 13.4283 13.8393 12.5 13.8393C11.5717 13.8393 10.6815 14.2098 10.0251 14.8693C9.36875 15.5289 9 16.4234 9 17.3561C9 18.2888 9.36875 19.1833 10.0251 19.8428C10.6815 20.5023 11.5717 20.8728 12.5 20.8728Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 3.79199H23.5V6.80637H20.5V8.81595H23.5V11.8303H25.5V8.81595H28.5V6.80637H25.5V3.79199Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add_photo.d76cbacaf5903fb8dbad874d1fa31c1f.svg";
export { ForwardRef as ReactComponent };